import Link from "next/link";
import { Button, Text, Stack } from "@chakra-ui/react";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import WrapCards from "@/components/cardsWrap";
import { ZADARA_SERVICES_CONSTANTS } from "./constants";

const ServicesComponent = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={6} align={"center"}>
      <WrapCards
        title={ZADARA_SERVICES_CONSTANTS.title}
        desc={ZADARA_SERVICES_CONSTANTS.desc}
        list={ZADARA_SERVICES_CONSTANTS.list}
      />
      <Stack spacing={4} align={"center"}>
        <Text variant={TextVariant} color="text.100">
          {ZADARA_SERVICES_CONSTANTS.conclusion}
        </Text>
        <Button
          as={Link}
          href={ZADARA_SERVICES_CONSTANTS.button.link}
          variant={BUTTON_VARIANTS.IDEAL}
          w={"fit-content"}
          p={6}
        >
          {ZADARA_SERVICES_CONSTANTS.button.label}
        </Button>
      </Stack>
    </Stack>
  );
};

export default ServicesComponent;
